import { Helmet } from 'react-helmet-async'
import { SITE_BASE_URL, FACEBOOK_APP_ID } from '../../constants'

const SITE_NAME = 'Breath Lab'
const DEFAULT_OG_IMAGE = `${SITE_BASE_URL}/og-image.png`

interface PageMetaProps {
  title: string
  description: string
  path: string
  image?: string
  ogType?: 'website' | 'article'
}

export function PageMeta({ title, description, path, image, ogType = 'website' }: PageMetaProps) {
  const fullTitle = title === SITE_NAME ? title : `${title} — ${SITE_NAME}`
  const canonicalUrl = `${SITE_BASE_URL}${path}`
  const ogImage = image ?? DEFAULT_OG_IMAGE

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="fb:app_id" content={FACEBOOK_APP_ID} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  )
}
